import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { UserAccessRolesEnum } from '../../../services/auth/auth.types';

/** Roles that may open `/shout-plus/admin` and see the nav item (GodMode only). */
export const SHOUT_PLUS_ADMIN_ACCESS_ROLES: readonly number[] = [
  UserAccessRolesEnum.GodMode,
];

export const shoutPlusAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn) {
    return router.createUrlTree(['/loading']);
  }

  const allowed = SHOUT_PLUS_ADMIN_ACCESS_ROLES.some((role) => auth.userRoles.includes(role));
  return allowed ? true : router.createUrlTree(['/not-allowed']);
};
